/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isObjectType
 */

export default function isObjectType(value) {
  return typeof value === 'object';
}
